import React from 'react'
import './myInformation.css'
import Vip_Icon from '../imageSrc/vip.png'
import user_pay from '../imageSrc/user_pay.png'
import nickname from '../imageSrc/nickname.png'
import Charge_Icon from '../imageSrc/charge.png'
import File_Account from '../imageSrc/file_account.png'
import Time_Use from '../imageSrc/time_use.png'
import Total_Length from '../imageSrc/total_length.png'
import {Progress} from 'antd'
import UDStruct from './upperDownStruct'
import {Switch} from 'antd'
import {fetchGet, fetchPost} from "../utils/fetchData";
import {message} from 'antd'
import {showErrorMsg} from "../utils/commonFunc";
import {convert_FormData_to_json2} from "../../config";

class UserInformation extends React.Component {
    constructor(props) {
        super(props);
        this.vipDes = '普通会员';
        this.state = {
            vipLevel:null,
            canServerAnalyse:0,
            totalFile:0,
            totalUseTime:0,
            usePercent:0,
            expireDate:0,
            wordNumber:0,
        }

    }

    setDes = (userInfo) => {
        if (userInfo.vipLevel === 'normal'){
            this.vipDes = '普通会员';
        } else {
            this.vipDes = '会员' + userInfo.vipLevel;
        }
    };

    getUserInfo = () => {
        let data = fetchGet('userInfo',null,null);
        data.then(data => {
            if (data.code === 200) {
                this.setDes(data.data);
                this.setState({
                    vipLevel : data.data.vipLevel,
                    anServerAnalyse : data.data.canServerAnalyse,
                    totalFile : data.data.totalFile,
                    totalUseTime : data.data.totalUseTime,
                    usePercent : data.data.usePercent,
                    expireDate : data.data.expireDate,
                    wordNumber : data.data.wordNumber,
                });
            } else {
                showErrorMsg(data);
            }
        })
    };

    saveNickName = () => {
        let nickName = this.refs.nickName.value;
        let formDataUpload = new FormData();
        formDataUpload.append("nickname", nickName);

        fetchPost('profile',convert_FormData_to_json2(formDataUpload),null)
            .then(data => {
                if (data.code === 200) {
                    message.success('修改成功');
                    global.loginUser.lguser_nickname = nickName
                    localStorage.setItem('nickName',global.loginUser.lguser_nickname)
                }
                else {
                    showErrorMsg(data);
                }
            })
    };

    componentDidMount(){
        this.props.triggerRef(this);
        this.getUserInfo();
        this.setNickNameText();
    }

    onChange = (checked) => {
        console.log('switch to ${checked}');
    };

    handleClickCharge = () => {
        this.props.recharge();
    };

    setNickNameText = (name)=> {
        if (this.refs.nickName !== undefined && this.refs.nickName.value !== undefined) {
            this.refs.nickName.value = global.loginUser.lguser_nickname;
            if (global.loginUser.lguser_nickname.length === 0) {
                this.refs.nickName.value = localStorage.getItem('nickName')
            }
        }
    }

    render(){
        let display = this.props.infoVisible?'block':'none';
        let display_vip = this.props.isVip?'inline':'none';
        return(
            <div style={{display:display}} className='div_myinfo_style'>
                <h2 className='title_myInfo_top'>个人信息</h2>


                <h6 className='account_type_style account'>昵称</h6>
                <input placeholder={global.loginUser.lguser_nickname} type="text" ref='nickName' className='user_nick_name'/>
                
                <img onClick={this.saveNickName} style={{width:"80px", height:"40px"}} src={nickname}/>
                <br/>
                <br/>

                {/* <h6 className='account_type_style account'>账户类型</h6>
                <img style={{display:display_vip}} className='img_account' src={Vip_Icon}/>
                <span style={{paddingLeft:12 + 'px',fontSize:12 + 'px'}}>{this.vipDes}</span>

                <div style={{display:'inline-block',width:32 + '%',height:2 + 'px',paddingLeft:10 + 'px'}} >
                    <Progress strokeColor='#5E5E5E'  percent={Number(this.state.usePercent)} showInfo={false} size='small'/>
                </div>
                
                <img onClick={this.handleClickCharge}  style={{width:"80px", height:"40px"}} src={user_pay}/> */}

                {/*<h6 className='account_type_style'>统计</h6>*/}
                {/*<div style={{width:120 + '%',height:80 + 'px'}}>*/}
                    {/*<UDStruct display={'inline'}*/}
                              {/*image={File_Account}*/}
                              {/*width={28}*/}
                              {/*height={28}*/}
                              {/*content={'文件数量:' + this.state.totalFile}/>*/}
                    {/*<UDStruct display={'inline'}*/}
                              {/*image={Time_Use}*/}
                              {/*width={28}*/}
                              {/*height={28}*/}
                              {/*content={'使用时长:' + this.state.totalUseTime + '小时'}/>*/}
                    {/*<UDStruct display={'inline'}*/}
                              {/*image={Total_Length}*/}
                              {/*width={28}*/}
                              {/*height={28}*/}
                              {/*content={'字数数量：' + this.state.wordNumber}/>*/}
                {/*</div>*/}

                {/*<h6 style={{display:'inline'}} className='account_type_style'>是否同意分析个人文本数据          </h6>*/}
                {/*<Switch defaultChecked size="small" onChange={this.onChange} />*/}
            </div>
        );
    }
}

export default UserInformation